(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .directive('recomUpdateStatusBackToDashboard', directive);

    function directive() {
        return {
            scope: {},
            restrict: 'AE',
            templateUrl: require('./backToDashboard.tpl.html'),
            controller: ['$scope', '$state', function($scope, $state) {

                // Back to Dashboard
                $scope.backToDashboard = function () {
                    $state.go('actionPlanUpdateStatusOwnerList', {
                        BusinessUnitCode: $state.params.BusinessUnitCode
                    });
                };
            }]
        }
    }
})();